module.exports = __webpack_public_path__ + "img/2.937df335.png";